import { AxiosApi } from "./index";
import { Registration, IRegistrationForm, RegistrationLine, RegistrationLineForm, RegistrationOverview, FisheryDepartmentNote } from "interface/registration";
import { ApiResponse } from "interface/response";
import { useInfoStore } from "store/error";

export interface RegistrationListParams {
    fromDate?: Date|null;
    toDate?: Date|null;
    registrationId?: number;
    fishingGearId?: number;
    fishingGear?: string
    vesselRegistrationNumber?: string;
    vesselName?: string;
    vesselId?: string;
    catchAreaCode?: string;
    speciesCode?: string;
    species?: string;
    buyerId?: number;
    buyerName?: string;
    skip: number;
    take: number;
  }

export interface RegistrationOverviewParams {
    vesselId?: string;
    vesselName?: string;
    catchField?: string;
    fishingGearId?: number;
    fishingGear?: string;
    species?: string;
    registrationTimeFrom?: Date | null;
    registrationTimeTo?: Date | null;
    landingTimeFrom?: Date | null;
    landingTimeTo?: Date | null;
}

export async function getRegistrationOverviewApi(params: RegistrationOverviewParams) {
    const apiUri = "Registration/Overview";
    try {
        const response = await AxiosApi.get<ApiResponse<RegistrationOverview[]>>(apiUri, { params });
        return response.data;
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}

  
export async function getCatchRegistrationListApi(params: RegistrationListParams) {
    const apiUri = "Registration/GetList"

    try {
        const registrations = await AxiosApi.get<ApiResponse<Registration[]>>(apiUri, {
            params: {
                ...params,
            }
        })
        return registrations.data
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}
  
export  async function getCatchRegistrationApi(id: number) {
    const apiUri = "Registration/Get";
   
   try {
      const registrations = await AxiosApi.get<ApiResponse<Registration[]>>(apiUri, {params:{
         id
      }})
      return registrations.data
   } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}



export async function getCatchRegistrationLineApi(registrationId: number, status: number) {
    const apiUri = "Registration/GetLines"

    try {
        const registrationLine = await AxiosApi.get<ApiResponse<RegistrationLine[]>>(apiUri, {
            params: {
                registrationId, status
            }
        })
        return registrationLine.data
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}

export  async function getRegistrationLineDetailApi(id: number) {
    const apiUri = "Registration/GetLine";
   
   try {
      const registrationLine = await AxiosApi.get<RegistrationLine[]>(apiUri, {params:{
         id
      }})
      return registrationLine.data
   } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}
export  async function createNewRegistrationApi(form: IRegistrationForm) {
    const apiUri = "Registration/new";
   
    //console.log('createNewRegistrationApi');

    try {
      const registrationLine = await AxiosApi.post<ApiResponse<IRegistrationForm>>(apiUri, form)
      return registrationLine.data
   } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}

export async function registrationEditingDataApi(registrationId: number) {
    const apiUri = "Registration/edit"


    try {
        const registration = await AxiosApi.get<ApiResponse<IRegistrationForm>>(apiUri, { params: { registrationId } })
        return registration.data
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}
export  async function addNewRegistrationLineApi(form: RegistrationLineForm) {
    const apiUri = "Registration/NewLine";
   
   try {
       const registrationLine = await AxiosApi.post<RegistrationLine>(apiUri, form)
      return registrationLine.data
   } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}

export  async function deleteTemporaryRegistrationLineApi(id: number, registrationId: number) {
    const apiUri = "Registration/DeleteLine";
   
   try {
      const registrationLine = await AxiosApi.delete<ApiResponse<RegistrationLine[]>>(apiUri, {params:{id, registrationId}})
      return registrationLine.data
   } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}

export async function setTemporaryRegistrationStepApi(id: number, step: number) {
    const apiUri = "registration/setStep";

    try {
        const registrationLine = await AxiosApi.get(apiUri, { params: { id, step } })
        return registrationLine.data
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}

export  async function getRegistrationLinesApi(registrationId: number,status: number) {
    const apiUri = "Registration/GetLines";
   
   try {
      const registrationLine = await AxiosApi.get<ApiResponse<RegistrationLine[]>>(apiUri, {params:{ registrationId, status}})
      return registrationLine.data
   } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}

export  async function deleteRegistrationApi(id: number,) {
    const apiUri = "Registration/Delete";
   
   try {
      const registrationLine = await AxiosApi.delete(apiUri, {params:{id}})
      return registrationLine.data
   } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}

export  async function completeRegistrationApi(id: number,) {
    const apiUri = "Registration/Complete";
   
   try {
      const registrationLine = await AxiosApi.post(apiUri, {id})
      return registrationLine.data
   } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}

export async function getFisheryDepartmentLandingNotesApi(id: number) {
    const apiUri = "Registration/FisheryDepartmentLandingNotes";
    try {
        const response = await AxiosApi.get<ApiResponse<FisheryDepartmentNote[]>>(apiUri, { params: { id } });
        return response.data;
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}

export async function getFisheryDepartmentSalesNotesApi(id: number) {
    const apiUri = "Registration/FisheryDepartmentSalesNotes";
    try {
        const response = await AxiosApi.get<ApiResponse<FisheryDepartmentNote[]>>(apiUri, { params: { id } });
        return response.data;
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}


